import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import AjusteEstoque1 from '../imagens/LancAjusteEstoque/AjusteEstoque1.png';
import AjusteEstoque2 from '../imagens/LancAjusteEstoque/AjusteEstoque2.png';
import AjusteEstoque3 from '../imagens/LancAjusteEstoque/AjusteEstoque3.png';
import AjusteEstoque4 from '../imagens/LancAjusteEstoque/AjusteEstoque4.png';
import AjusteEstoque5 from '../imagens/LancAjusteEstoque/AjusteEstoque5.png';
import AjusteEstoque6 from '../imagens/LancAjusteEstoque/AjusteEstoque6.png';

export default class AjusteEstoque extends Component {

  render() {

    const { isOpen, onClose } = this.props;

    return (
      <Modal
        title="Como fazer ajustes de Estoque"
        className="modal"
        visible={isOpen}
        destroyOnClose
        onCancel={onClose}
        footer={null}
        width="50%"
        style={{ top: 10 }}
      >
        <Row>
          <Col xs={24}>
            <p>Para acessar o ajuste de Estoque siga o seguinte atalho:  </p>

            <div className="image-wrapper">
              <img className="img_smaller" src={AjusteEstoque1} alt="Ajuste 1"/>
            </div>     

            <div className="gray_bar"></div>  

            <div className="image-wrapper">
              <img src={AjusteEstoque2} alt="Ajuste 2"/>
            </div>             
                 
          <h3>Na tela de Ajuste de Estoque nós temos:</h3>
            <ol>
                <li>Filtro de data para filtrar os ajustes feitos.</li> 
                <li>Criar um novo ajuste de Estoque.</li>
                <li>Tabela mostrando todas os Ajustes de Estoque feitos.</li>
                <li>Paginação da tabela de Ajustes de Estoque.</li>
                <li>Botões auxiliares para exclusão de um Ajuste de Estoque.</li>                
            </ol>   

            <div className="gray_bar"></div>              

            <h3>Como fazer um Ajuste de Estoque</h3>

            <p>Para fazer um ajuste no Estoque de um item basta clicar no botão </p>

            <div className="image-wrapper">
              <img src={AjusteEstoque3} alt="Ajuste 3"/>
            </div> 

            <p>
                Dentro do cadastro de Ajuste, primeiramente selecione o produto do estoque ao qual você deseja gravar um ajuste. Após selecionar um produto, a quantidade  
                atual de estoque do produto será exibida no campo "Qtde Atual", e o gestor poderá colocar qual a quantidade correta no campo "Qtd Contada". Depois que o 
                gestor digitar a quantidade contada, o sistema irá exibir a diferença entre a quantidade atual e a quantidade contada no campo "Diferença". 
                O gestor pode também mudar o valor unitário do item no campo "Valor Unit". 
                Ao terminar de preencher os dados, basta que o gestor clique no botão "Gravar" para salvar o ajuste e alterar o estoque do item.            
            </p> 
            <p>Assim que o ajuste for salvo a quantidade de estoque do produto será atualizada.</p> 

            <div className="image-wrapper">
              <img src={AjusteEstoque4} alt="Ajuste 4"/>
            </div>       

            <div className="gray_bar"></div>                

            <h3>Como excluir um Ajuste do Estoque</h3>

            <p>Caso seja necessário excluir um Ajuste do Estoque basta utilizar o botão de exclusão dentro da tabela de registros.</p>   
            <p>Logo que o Ajuste de estoque for excluído, a quantidade de estoque do poduto será atualizada</p>               
            
            <div className="image-wrapper">
              <img src={AjusteEstoque5} alt="Ajuste 5"/>
            </div>   

            <div className="gray_bar"></div>                

            <h3>Como filtrar os ajustes de estoque</h3>

            <p>
              Para facilitar na busca de um ajuste específico você pode utilizar o filtro de data 
            </p> 

            <div className="image-wrapper">
              <img src={AjusteEstoque6} alt="Ajuste 6"/>
            </div>                       

          </Col>
        </Row>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancAjusteEstoque.js